import { useQuery, gql, QueryResult, OperationVariables, FetchResult, MaybeMasked, ApolloError } from '@apollo/client'
import { client } from '../../..'
import { GetOnboardingDataQueryVariables, GetOnboardingDataQuery } from '../../../types'

const ONBOARDING_DATA = gql`
  query GetOnboardingData($iframeId: String!) {
    getOnboardingData(iframeId: $iframeId) {
      setCookieUrl
      authUrl
      damUrl
      redirectUrlQueryParamName
      queryParamsString
    }
  }
`

export const useOnboardingData = (
  iframeId: string,
): {
  data: GetOnboardingDataQuery | undefined
  loading: boolean
  error: ApolloError | undefined
} => {
  const { data, loading, error } = useQuery<GetOnboardingDataQuery, GetOnboardingDataQueryVariables>(ONBOARDING_DATA, {
    variables: { iframeId },
  })
  return { data, loading, error }
}

const ONBOARDING_PERMISSION = gql`
  query checkOnboardingPermission {
    checkOnboardingPermission
  }
`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useOnboardingPermission = (): QueryResult<any, OperationVariables> => {
  return useQuery(ONBOARDING_PERMISSION)
}

const ONBOARDING_VISIBILITY = gql`
  query checkVisibilityOnboarding {
    checkVisibilityOnboarding
  }
`
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useOnboardingVisibility = (): QueryResult<any, OperationVariables> => {
  return useQuery(ONBOARDING_VISIBILITY, { fetchPolicy: 'network-only' })
}

export const UPDATE_ONBOARDING_DATE = gql`
  mutation updateOnboardingDate {
    updateOnboardingDate
  }
`

export const updateOnboardingDate = async (): Promise<FetchResult<MaybeMasked<boolean>>> => {
  return client.mutate({
    mutation: UPDATE_ONBOARDING_DATE,
  })
}
